import { render, staticRenderFns } from "./fission-campagin-view.vue?vue&type=template&id=4c601194&scoped=true"
import script from "./fission-campagin-view.vue?vue&type=script&lang=ts"
export * from "./fission-campagin-view.vue?vue&type=script&lang=ts"
import style0 from "./fission-campagin-view.vue?vue&type=style&index=0&id=4c601194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c601194",
  null
  
)

export default component.exports